import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { ShowExpanded, Amount, Date } from '../shared';
import HistoryDetails from './HistoryDetails';

import './HistoryItem.less';

@observer class HistoryItem extends Component {
  constructor() {
    super();
    this.state = { expanded: false };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState(state => ({ expanded: !state.expanded }));
  }
  render() {
    const { expanded } = this.state;
    const { item, contact } = this.props;
    let details = null;

    if (expanded) {
      details = (
        <div>
          <HistoryDetails item={item} contact={contact} />
        </div>
      );
    }
    let amount = 0;
    if (contact.credShow) {
      amount = item.lCostpx
    }  else{
      amount = item.unitPx
    }

    return (
      <div className="list-group-item">
        <div onClick={this.toggle}>
          <ShowExpanded expanded={expanded} />
          {item.artCode}
          <span className="ship-mth">
            ({item.hstAhShipMth.substr(0, 3)})
          </span>

          <span className="pull-right">
            <span className="unit-px">
              <Amount amount={amount} />
            </span>
            /
            <span className="art-unit">
              {item.artUnit}
            </span>
          </span>
        </div>
        <div onClick={this.toggle}>
          <span className="inv-date">
            <Date value={item.hstAhInvDate} />
          </span>
        </div>
        {details}
      </div>
    );
  }
}

export default HistoryItem;



// WEBPACK FOOTER //
// ./src/history/HistoryItem.js